import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/vip.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-b0ceece6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "addPage" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"20px"}
}, null, -1))

import { ref, watchEffect } from "vue";
import API from "@/api";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";
import {
  addAppUsingPost,
  editAppUsingPost,
  getAppVoByIdUsingGet,
} from "@/api/appController";
import {
  APP_SCORING_STRATEGY_MAP,
  APP_TYPE_MAP,
} from "../../../constant/appEnum";
import PictureUpload from "@/components/picture/PictureUpload.vue";

interface Props {
  appId: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'addAppPage',
  props: {
    appId: { default: () => {
    return 0;
  } }
  },
  setup(__props: any) {

const router = useRouter();
const form = ref({
  appType: 1,
  scoringStrategy: 0,
} as API.AppAddRequest);

const props = __props;

const titleText = ref("创建");
const oldApp = ref<API.AppVO>({});
/**
 * 加载数据
 */
const loadData = async () => {
  if (!props.appId) {
    return;
  }
  titleText.value = "修改";
  const response = await getAppVoByIdUsingGet({
    id: props.appId,
  });
  if (response.data.code === 0 && response.data.data) {
    oldApp.value = response.data.data;
    form.value = response.data.data;
  } else {
    message.error("加载数据失败，" + response.data.message);
  }
};

/**
 * 监听 searchParams 变量，改变时触发数据的重新加载
 */
watchEffect(() => {
  loadData();
});

/**
 * 创建或修改应用
 */
const submitApp = async () => {
  if (!form.value.appName) {
    message.error("应用名称不能为空");
    return;
  }
  let response: any;
  //有就是修改
  if (props.appId) {
    response = await editAppUsingPost({
      id: props.appId,
      ...form.value,
    });
    //有就是修改
  } else {
    response = await addAppUsingPost(form.value);
  }
  if (response.data.code === 0) {
    message.success("操作成功!");
    router.push(
      `/app/detail/${props.appId == 0 ? response.data.data : props.appId}`
    );
  } else {
    message.error("操作失败，" + response.data.message);
  }
};
const rules = {
  appName: [
    {
      required: true,
    },
  ],
  appType: [
    {
      required: true,
    },
  ],
  scoringStrategy: [
    {
      required: true,
    },
  ],
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, "应用" + _toDisplayString(titleText.value), 1),
    _hoisted_2,
    _createVNode(_component_a_form, {
      model: form.value,
      style: { width: '400px' },
      "label-align": "left",
      "auto-label-width": "",
      onSubmit: submitApp,
      rules: rules
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          field: "appName",
          label: "应用名称",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: form.value.appName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.appName) = $event)),
              placeholder: "请输入应用名称..."
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "appDesc",
          label: "应用描述"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: form.value.appDesc,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.appDesc) = $event)),
              placeholder: "请输入应用描述..."
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "appIcon",
          label: "应用图标",
          tooltip: "输入图标链接"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_space, { size: "large" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_a_image, {
                  src: form.value.appIcon,
                  width: "80px"
                }, null, 8, ["src"]), [
                  [_vShow, form.value.appIcon]
                ]),
                _createVNode(PictureUpload, {
                  biz: "app_icon",
                  value: form.value.appIcon,
                  onChange: (url) => (form.value.appIcon = url)
                }, null, 8, ["value", "onChange"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "appType",
          label: "应用类型",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio_group, {
              modelValue: form.value.appType,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.appType) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio, { value: 1 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(APP_TYPE_MAP)[1]), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_radio, {
                  value: 0,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (form.value.scoringStrategy = 0))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(APP_TYPE_MAP)[0]), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "scoringStrategy",
          label: "评分策略",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio_group, {
              modelValue: form.value.scoringStrategy,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.scoringStrategy) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio, { value: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(APP_SCORING_STRATEGY_MAP)[0]), 1)
                  ]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_a_radio, { value: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(APP_SCORING_STRATEGY_MAP)[1]) + " ", 1),
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, form.value.appType == 1]
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          "html-type": "submit",
          style: {"width":"100px","margin":"0 auto 10px"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(titleText.value) + "应用 ", 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})